import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { needsLoading, GoAction, QueueAlertAction, AlertType } from '@app/core';
import { selectPolicies, LoadingPolicyAction, RemovePolicyByIdAction } from './index';
import { SelectPolicyAction } from './policy-details/policy-details.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var shouldLoadPolicies = function (policies) { return needsLoading(policies); };
var ɵ0 = shouldLoadPolicies;
var hasPoliciesState = function (policies) { return !needsLoading(policies); };
var ɵ1 = hasPoliciesState;
var PoliciesFacadeService = /** @class */ (function () {
    function PoliciesFacadeService(store) {
        this.store = store;
        this.policies$ = of();
    }
    PoliciesFacadeService.prototype.initialize = function () {
        var _this = this;
        var maybePolicies$ = this.store.pipe(select(selectPolicies));
        maybePolicies$.pipe(take(1), filter(shouldLoadPolicies))
            .subscribe(function () { return _this.store.dispatch(new LoadingPolicyAction()); });
        this.policies$ = maybePolicies$.pipe(filter(hasPoliciesState));
    };
    PoliciesFacadeService.prototype.selectPolicy = function (row) {
        this.store.dispatch(new SelectPolicyAction(row));
        this.store.dispatch(new GoAction(['/iam/policies/', row.id, 'edit']));
    };
    PoliciesFacadeService.prototype.removePolicy = function (policyId) {
        this.store.dispatch(new RemovePolicyByIdAction(policyId));
        this.store.dispatch(new QueueAlertAction({
            alertText: "Policy delete succeed.", alertType: AlertType.SUCCESS
        }));
    };
    PoliciesFacadeService.prototype.failedRemovePolicy = function () {
        this.store.dispatch(new QueueAlertAction({ alertText: "Policy delete failed.", alertType: AlertType.ERROR }));
    };
    PoliciesFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function PoliciesFacadeService_Factory() { return new PoliciesFacadeService(i0.inject(i1.Store)); }, token: PoliciesFacadeService, providedIn: "root" });
    return PoliciesFacadeService;
}());
export { PoliciesFacadeService };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/access-management/state/policies.facade.ts.pre-build-optimizer.js